export class QualityControlConcrete {
    id!: string
    job!: string
    structureType!: string
    partOfTheStructure!: string
    designPsi!: string
    supplier!: number | undefined
    addMixturesRequired!: string
    maxWaterRatio!: string
    gallonsAllowedToAdd!: string
    slumpRequirement!: string
    cylindersNeeded!: string
    airRequirement!: string
    twentyEightDayStrength!: string
    curingReqNumberOfTestRequired!: string
    maxLifts!: string
    maxTimeOnLifts!: string
    timeToPourAllowed!: string
    minTemperatureRequired!: string
    createdOn!: Date
    modifiedOn!: Date
}
